import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { send_request } from '../../../utils/Request';
import ConfirmDestructiveActionDialog from '../../W86Components/ConfirmDestructiveActionDialog';

function ConfirmTerminateMultipleSessionsDialog({
  isOpen,
  close,
  sessionIds,
  terminateSessions,
}) {
  const [user, setUser] = useState(null);
  const [isTerminating, setIsTerminating] = useState(false);

  useEffect(() => {
    const loadUsername = async () => {
      const json = await send_request(`authz-service/user-info`, '', {});
      if (json && json.data) setUser(json.data.displayName);
    };
    loadUsername();
  }, []);

  const sessionCount = sessionIds?.length || 0;

  return (
    <ConfirmDestructiveActionDialog
      open={isOpen}
      title="Confirm terminate multiple sessions"
      headerDetail={
        <>
          <strong>{user || <Skeleton variant="text" width={125} sx={{ display: 'inline-block' }} />}</strong>{' '}
          is terminating {sessionCount} session{sessionCount !== 1 ? 's' : ''}
        </>
      }
      warning={
        <>
          You are about to terminate {sessionCount} session{sessionCount !== 1 ? 's' : ''}. This
          will terminate and stop all components within these sessions from running further.
        </>
      }
      confirmPhrase="terminate"
      confirmLabel={`Terminate ${sessionCount} Session${sessionCount !== 1 ? 's' : ''}`}
      loading={isTerminating}
      manageLoading={false}
      confirmDisabled={sessionCount === 0}
      onClose={close}
      onConfirm={async () => {
        setIsTerminating(true);
        try {
          await terminateSessions(sessionIds);
          close();
        } finally {
          setIsTerminating(false);
        }
      }}
    />
  );
}

export default ConfirmTerminateMultipleSessionsDialog;
